//Used to display DSA leads and generate invoices for DSA partners against customers who have paid atleast their first EMI.


import React, { Component } from 'react';
import { loadProgressBar } from 'axios-progress-bar';
import ReactTable from 'react-table';
import { FormGroup, Modal, ModalHeader, ModalBody, ModalFooter, Container, Row, Col, Input } from 'reactstrap';
import * as Constant from '../../../constants/AppConstants';
import jsPDF from 'jspdf'
// import html2canvas from 'html2canvas';



loadProgressBar();

class generateInvoice extends Component {
    constructor(props) {
        super(props);

        this.state = {

            timeouterror: '',
            // dsaOptions: [
            //     { value: "", label: "Select a DSA Partner" },
            //     { value: "1", label: "DSA1" },
            //     { value: "2", label: "DSA2" },
            //     { value: "3", label: "DSA3" }
            // ],
            dsaOptions: [],
            errmsg: '',
            dsaFields: [],
            errInvmsg: '',
            inv_approved_amt: '',
            inv_month: '',
            inv_adjust_amt: '',
            inv_comment: '',
            inv_payout_amt: '',
            inv_payout_percent: '',
            inv_total: '',
            inv_cgst: '',
            inv_sgst: '',
            inv_igst: '',
            inv_grandTotal: '',
            inv_invoiceNumber: '',
            msg: '',
            invoiceModal: false,
            count: 0,
            dsaInvData: [],
            inv_gst_enable: "0",
            invoice_html:`<html><body><table>
            <tr>
              <th>Entry Header 1</th>
              <th>Entry Header 2</th>
              <th>Entry Header 3</th>
              <th>Entry Header 4</th>
            </tr>
            <tr>
              <td>Entry First Line 1</td>
              <td>Entry First Line 2</td>
              <td>Entry First Line 3</td>
              <td>Entry First Line 4</td>
            </tr>
            <tr>
              <td>Entry Line 1</td>
              <td>Entry Line 2</td>
              <td>Entry Line 3</td>
              <td>Entry Line 4</td>
            </tr>
            <tr>
              <td>Entry Last Line 1</td>
              <td>Entry Last Line 2</td>
              <td>Entry Last Line 3</td>
              <td>Entry Last Line 4</td>
            </tr>
          </table></body></html>`,
            invoice_html:'',

        };
        this.getDSAOptions = this.getDSAOptions.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleOptionChange = this.handleOptionChange.bind(this);
        this.getInvoice = this.getInvoice.bind(this);
    }

    componentDidMount() {

        //Calculate current date. 
        var d = new Date();
        var n = d.getMonth();
        var y = d.getFullYear();
        var curMonth = y + "-" + (n + 1);

        let temp_dsaFieldsMonth = this.state.dsaFields;
        temp_dsaFieldsMonth["month"] = ''

        this.setState({ dsaFields: temp_dsaFieldsMonth });
        //Get names of DSA organizations
        this.getDSAOptions();
    }

    getDSAOptions() {

        var self = this;
        self.setState({ errmsg: "" });

        var querystring = require('querystring');

        var payload = querystring.stringify({
            mode: Constant.GET_DSA_ORGANIZATIONS,

        });

        axios({
            method: 'post',
            url: Constant.API_URL,
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
            },
            withCredentials: false,
            data: payload,
        })
            .then(function (response) {
                if (response.status == 200) {
                    self.setState(prevState => ({
                        dsaOptions: response.data,
                    }));
                    // var count=Object.keys(self.state.dsaOptions).length;

                }

                else if (response.status == 201) {

                    self.setState(prevState => ({
                        errmsg: response.data.error,
                    }));
                }

            }).catch(function (error) {
                self.setState(prevState => ({
                    errmsg: "Error :  " + error,
                }));

                // console.log(`Error:`, response.status);
            });
    }

    //handle and validate change to DSA month and Name

    handleChange(field, e) {
        this.setState({
            dsaData: []
        });

        var d = new Date();


        let temp_dsaFields = this.state.dsaFields;
        temp_dsaFields[field] = e.target.value;

        this.setState({

            dsaFields: temp_dsaFields
        });

        if (this.state.dsaFields["month"].split('-')[0] < 2017 || this.state.dsaFields["month"].split('-')[0] > d.getFullYear()) {
            this.setState({
                errmsg: 'Enter a year between 2017 and ' + d.getFullYear()
            });

        }

        else if (this.state.dsaFields["dsa"] == "0" || this.state.dsaFields["dsa"] == "" || this.state.dsaFields["dsa"] == null) {


            this.setState({
                errmsg: "Please select a valid DSA Partner"
            });
        }
        else if (this.state.dsaFields["month"] == "0" || this.state.dsaFields["month"] == "" || this.state.dsaFields["month"] == null) {


            this.setState({
                errmsg: "Please select a valid month/year"
            });
        }

        else { this.handleOptionChange(); }

    }

    handleOptionChange() {


        var self = this;
        self.setState({
            errmsg: ""

        });

        console.log(self.state.errmsg);

        var querystring = require('querystring');

        var payload = querystring.stringify({
            mode: Constant.GET_DSA_INFO,
            org_id: self.state.dsaFields["dsa"],
            month: self.state.dsaFields["month"]
        });
        axios({
            method: 'post',
            url: Constant.API_URL,
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
                'token': window.localStorage.getItem(Constant.TOKEN)

            },
            withCredentials: false,
            data: payload,
        })
            .then(function (response) {
                if (response.status == 200) {
                    self.setState(prevState => ({
                        dsaData: response.data.leads,
                        errmsg: ''
                    }));

                }
                else if (response.status == 201) {

                    self.setState({
                        errmsg: response.data.error
                    });


                }
            }).catch(function (error) {

                self.setState({
                    // errmsg:error
                });

            });
    };


    //Show invoice details in a popup window before an actual invoice is confirmed to be generated.

    handleInvoiceGenerate = (e) => {

        this.setState({
            timeouterror: '',
            errmsg: '',
            inv_invoiceNumber:''
        })

        var self = this;


        if (self.state.dsaFields["dsa"] == "0" || self.state.dsaFields["dsa"] == 0 || self.state.dsaFields["dsa"] == '' || self.state.dsaFields["dsa"] == null) {
            self.setState({
                errmsg: 'Please select a valid DSA Partner'
            });

            return;
        }
        else if (self.state.dsaFields["month"] == "0" || self.state.dsaFields["month"] == 0 || self.state.dsaFields["month"] == '' || self.state.dsaFields["month"] == null) {
            self.setState({
                errmsg: 'Please select a valid month/year'
            });

            return;
        }
        var querystring = require('querystring');

        var payload = querystring.stringify({
            mode: Constant.GENERATE_INVOICE,
            month: self.state.dsaFields["month"],
            org_id: self.state.dsaFields["dsa"],

        });

        axios({
            method: 'post',
            url: Constant.API_URL,
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
                'token': window.localStorage.getItem(Constant.TOKEN)

            },
            withCredentials: false,
            data: payload,
            timeout: 30000
        })
            .then(function (response) {

                if (response.status == 200) {
                    self.setState(prevState => ({
                        inv_approved_amt: response.data.approved_amt,
                        inv_month: response.data.month,
                        inv_adjust_amt: response.data.adjust,
                        inv_comment: response.data.comment,
                        inv_payout_amt: response.data.payout,
                        inv_payout_percent: response.data.payout_percent,
                        inv_total: response.data.total,
                        inv_cgst: response.data.cgst,
                        inv_sgst: response.data.sgst,
                        inv_igst: response.data.igst,
                        inv_grandTotal: response.data.grand_total,
                        dsaInvData: response.data.leads,
                        inv_gst_enable: response.data.gst_enable

                    }));
                    self.getInvoice();
                }
                else if (response.status == 201) {
                    self.setState(prevState => ({
                        errmsg: response.data.error,
                    }));
                }

            }).catch(function (error) {
                if (error.code == 'ECONNABORTED') {
                    self.setState({ timeouterror: 'Request timed out. Please try again after sometime' });
                }
                else {
                    self.setState(prevState => ({
                        errmsg: error,
                    }));
                }
            });
    }

   

    //Open/close invoice modal

    getInvoice() {
        this.setState({
            invoiceModal: !this.state.invoiceModal
        });
    }

    //Validate and set invoice number by DSA partner
    handleInvoiceNumberChange = (e) => {

        this.setState({
            inv_invoiceNumber: e.target.value
        });

    }

    //Confirm generation of invoice. Invoice is generated in another tab.

    // handleConfirmInvoiceGenerate = (e) => {

    //     e.preventDefault();
    //     var pdf;

    //     var self = this;
    //     self.setState({
    //         timeouterror: '',
    //         errmsg: '',
    //         errInvmsg: ''
    //     });
    //     var querystring = require('querystring');

    //     var payload = querystring.stringify({
    //         mode: Constant.CONFIRM_INVOICE_GENERATE,
    //         month: self.state.dsaFields["month"],
    //         org_id: self.state.dsaFields["dsa"],
    //         invoice: self.state.inv_invoiceNumber

    //     });

    //     axios({
    //         method: 'post',
    //         url: Constant.API_URL,
    //         headers: {
    //             'content-type': 'application/x-www-form-urlencoded',
    //             'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN)

    //         },
    //         withCredentials: false,
    //         data: payload,
    //         timeout: 20000
    //     })
    //         .then(function (response) {
    //             if (response.status == 200) {
    //                 self.setState(prevState => ({
    //                     msg: 'Successfully generated Invoice',
    //                     invoice_html: response.data.invoice_html
    //                 }));
    //                 pdf = this.exportPdf();
    //                 this.sendPDF(pdf);
    //                 // window.location.reload();
    //             }
    //             else if (response.status == 201) {
    //                 self.setState(prevState => ({
    //                     errInvmsg: response.data.error,
    //                 }));
    //             }

    //         }).catch(function (error) {
    //             if (error.code == 'ECONNABORTED') {
    //                 self.setState({ timeouterror: 'Request timed out. Please try again after sometime' });
    //             }
    //             else {
    //                 self.setState(prevState => ({
    //                     errmsg: error,
    //                 }));
    //             }
    //         });
    // }
    handleConfirmInvoiceGenerate = (e) => {

        e.preventDefault();


        var self = this;
        self.setState({
            timeouterror: '',
            errmsg: '',
            errInvmsg: ''
        });
        var querystring = require('querystring');

        var payload = querystring.stringify({
            mode: Constant.CONFIRM_INVOICE_GENERATE,
            month: self.state.dsaFields["month"],
            org_id: self.state.dsaFields["dsa"],
            invoice: self.state.inv_invoiceNumber

        });

        axios({
            method: 'post',
            url: Constant.API_URL,
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN),
                'token': window.localStorage.getItem(Constant.TOKEN)

            },
            withCredentials: false,
            data: payload,
            timeout: 20000
        })
            .then(function (response) {
                if (response.status == 200) {
                    self.setState(prevState => ({
                        msg: 'Successfully generated Invoice',
                        link: response.data.url
                    }));
                    Object.assign(document.createElement('a'), {
                        target: '_blank', href: self.state.link
                    }).click();
                    window.location.reload();
                }
                else if (response.status == 201) {
                    self.setState(prevState => ({
                        errInvmsg: response.data.error,
                    }));
                }

            }).catch(function (error) {
                if (error.code == 'ECONNABORTED') {
                    self.setState({ timeouterror: 'Request timed out. Please try again after sometime' });
                }
                else {
                    self.setState(prevState => ({
                        errmsg: error,
                    }));
                }
            });
    }

    // exportPdf=()=>{ 
    //     var self = this;

    //     document.getElementById("demo").innerHTML = self.state.invoice_html;
    //     document.getElementById("pdf").style.display="block";
    //     const input = document.getElementById('demo');
    //     html2canvas(input)
    //     .then((canvas) => {
    //         document.getElementById("pdf").style.display="none";
    //         const imgData = canvas.toDataURL('image/png');
    //         const pdf = new jsPDF();
    //         pdf.addImage(imgData, 'JPEG', 0, 0);

    //         // pdf.output('dataurlnewwindow');
    //         console.log(pdf);
    //         pdf.save("download.pdf");

    //         return pdf;

    //     });
    // }
    
    // sendPDF=(pdf)=>{

    //     var self=this;

    //     var payload = new FormData();
    //     payload.append("mode", Constant.SEND_INVOICE_PDF);
    //     payload.append("month", self.state.dsaFields["month"]);
    //     payload.append("org_id", self.state.dsaFields["dsa"]);
    //     payload.append("pdf", pdf);

    //     axios({
    //         method: 'post',
    //         url: Constant.API_URL,
    //         headers: {
    //             'content-type': 'multipart/form-data',
    //             'auth_token': window.localStorage.getItem(Constant.AUTH_TOKEN)

    //         },
    //         withCredentials: false,
    //         data: payload,
    //         timeout: 20000
    //     })
    //         .then(function (response) {
    //             if (response.status == 200) {
    //                 self.setState(prevState => ({
    //                     msg: 'Successfully generated Invoice',
    //                     // invoice_html: response.data.invoice_html
    //                 }));
    //                 // this.exportPdf();
    //                 // this.sendPDF();
    //                 window.location.reload();
    //             }
    //             else if (response.status == 201) {
    //                 self.setState(prevState => ({
    //                     errInvmsg: response.data.error,
    //                 }));
    //             }

    //         }).catch(function (error) {
    //             if (error.code == 'ECONNABORTED') {
    //                 self.setState({ timeouterror: 'Request timed out. Please try again after sometime' });
    //             }
    //             else {
    //                 self.setState(prevState => ({
    //                     errmsg: error,
    //                 }));
    //             }
    //         });

    // }


    render() {
        // const dsaData = [{
        //     loanID: 123,
        //     leadName: 'Ajay Singh',
        //     emiStatus: 'paid',
        //     emiAmount: '10000',
        //     emiDate: '09/02/2019',
        //     firstEmiDate: "09/02/2019"
        // }];
        const columns = [{
            Header: 'Loan ID',
            accessor: 'loan_id'
        }, {
            Header: 'Lead name',
            accessor: 'name'

        }, {
            Header: 'First EMI Status',
            accessor: 'emi_status'

        }, {
            Header: 'EMI Amount',
            accessor: 'emi_amount',

        }, {
            Header: 'First EMI Date',
            accessor: 'emi_date'
        },

        ];
        const Invcolumns = [{
            Header: 'Loan ID',
            accessor: 'loan_id'
        }, {
            Header: 'Lead name',
            accessor: 'name'

        }, {
            Header: 'First EMI Status',
            accessor: 'emi_status'

        }, {
            Header: 'EMI Amount',
            accessor: 'emi_amount',

        }, {
            Header: 'First EMI Date',
            accessor: 'emi_date'
        },

        ];

        const { dsaOptions } = this.state;
        const { dsaData } = this.state;
        const { dsaInvData } = this.state;


        return (
            <div>
                <Container>
                    <Row>
                        <div className="generateInv">

                            <div className="generateInv__header">
                                Generate Invoice
                            </div>

                            <div className="generateInv__body">
                                <div className="generateInv__body__month-options">

                                    <Col xs="12" sm="3" md="3" lg="3">
                                        <input type="month"
                                            className="generateInv__body__month-options__input"
                                            value={this.state.dsaFields["month"]}
                                            onChange={this.handleChange.bind(this, "month")}
                                            min="2017-01"
                                        />

                                    </Col>

                                    <Col xs="12" sm="3" md="3" lg="3">

                                        <select className="dsaChangeDropdown" onChange={this.handleChange.bind(this, "dsa")}
                                            value={this.state.dsaFields["dsa"]}>
                                            <option value="0">Select a DSA Partner</option>
                                            {dsaOptions.map((data, key) =>
                                                <option key={key} value={data.id}>{data.name}</option>
                                            )}
                                        </select>

                                        {/* <button onClick={this.exportPdf}>Export PDF</button> */}

                                    </Col>


                                </div>
                            </div>
                            <div className="generateInv__body__table">
                                <ReactTable data={dsaData} columns={columns} defaultPageSize={10}
                                />
                            </div>
                            <FormGroup>
                                <Col xs="12" sm="6" md="6" lg="6">

                                    {this.state.errmsg ?
                                        <div className="errorMessage">
                                            {this.state.errmsg}
                                        </div>
                                        : ""
                                    }
                                    {this.state.timeouterror ?
                                        <div className="errorMessage">
                                            {this.state.timeouterror}
                                        </div>
                                        :
                                        ""
                                    }

                                </Col>
                                <Col xs="6" sm="6" md="6" lg="6">

                                    <button type="submit" className="generateInv__body__generate_button" onClick={this.handleInvoiceGenerate.bind(this)}>Generate</button>

                                </Col>
                            </FormGroup>
                        </div>
                    </Row>
                </Container>
                <div id="pdf" style={{display: "none"}}>
                    <div id="demo" className="mt4" style={{
                        backgroundColor: '#ffffff',
                        width: '210mm',
                        minHeight: '297mm',
                        margin: '10px',
                        height: '550',
                        padding: '10px'
                    }}>
                    </div>
                </div>

                <Modal isOpen={this.state.invoiceModal} size='lg' toggle={this.getInvoice} className={this.props.className}>
                    <ModalHeader toggle={this.getInvoice}>Confirm Invoice Generation</ModalHeader>
                    <ModalBody className="inv_confirm">
                        <Row>
                            <label className="confirmInvoiceHeading">
                                Lead Details
                            </label>
                            <div className="ConfirmGenerateInv__body__table">
                                <ReactTable data={dsaInvData} columns={Invcolumns} defaultPageSize={5}
                                />
                            </div>
                        </Row>
                        <Row>
                            <Col>
                                <label>Approved Amount
                                    <input type="number" readOnly className="dsaPayments__paymentSlab" value={this.state.inv_approved_amt} />
                                </label>
                            </Col>
                            <Col>
                                <label>Month
                                    <input type="text" readOnly className="dsaPayments__paymentSlab" value={this.state.inv_month} />
                                </label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <label>Adjustment Amount
                                    <input type="number" readOnly className="dsaPayments__paymentSlab" value={this.state.inv_adjust_amt} />
                                </label>
                            </Col>
                            <Col>
                                <label>Comment
                                    <input type="text" readOnly className="dsaPayments__paymentSlab" value={this.state.inv_comment} />
                                </label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <label>Payment Amount
                                    <input type="number" readOnly className="dsaPayments__paymentSlab" value={this.state.inv_payout_amt} />
                                </label>
                            </Col>
                            <Col>
                                <label>Payout %
                                    <input type="number" readOnly className="dsaPayments__paymentSlab" value={this.state.inv_payout_percent} />
                                </label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <label>Total
                                    <input type="number" readOnly className="dsaPayments__paymentSlab" value={this.state.inv_total} />
                                </label>
                            </Col>
                        </Row>
                        {
                            this.state.inv_gst_enable == "1" && this.state.inv_cgst ?
                                <Row>
                                    <Col>
                                        <label>CGST
                                    <input type="number" readOnly className="dsaPayments__paymentSlab" value={this.state.inv_cgst} />
                                        </label>
                                    </Col>

                                    <Col>
                                        <label>SGST
                                    <input type="number" readOnly className="dsaPayments__paymentSlab" value={this.state.inv_sgst} />
                                        </label>
                                    </Col>
                                </Row>
                                :
                                ""
                        }
                        {
                            this.state.inv_gst_enable == "1" && this.state.inv_cgst == "" ?
                                <Row>
                                    <Col>
                                        <label>IGST
                                    <input type="number" readOnly className="dsaPayments__paymentSlab" value={this.state.inv_igst} />
                                        </label>
                                    </Col>
                                </Row>

                                :
                                ""
                        }

                        <Row>

                            <Col>
                                <label>Grand Total
                                    <input type="number" readOnly className="dsaPayments__paymentSlab" value={this.state.inv_grandTotal} />
                                </label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                Enter an invoice number <input className="inv_invoice_number" value={this.state.inv_invoiceNumber}
                                    onChange={this.handleInvoiceNumberChange.bind(this)}></input>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        {this.state.errInvmsg ?
                            <div className="errorMessage">
                                {this.state.errInvmsg}
                            </div>
                            : ""
                        }
                        <button className="confirmInvoiceSubmitBtn" color="primary" onClick={this.handleConfirmInvoiceGenerate}>Confirm Invoice</button>
                    </ModalFooter>
                </Modal>

            </div>
        );

    }
}

export default generateInvoice;




// WEBPACK FOOTER //
// ./src/views/Pages/generateInvoice/generateInvoice.js